import * as Yup from 'yup'
import { cloneDeep } from 'lodash-es'

export enum HELP_FORM_FIELDS {
  FULLNAME = 'fullName',
  EMAIL = 'email',
  MOBILE = 'mobile',
  IMAGE = 'image',
  MESSAGE = 'message',
  STATUS = 'status'
}

export enum EnquiryStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  RESOLVED = 'RESOLVED'
}
export interface HelpForm {
  [HELP_FORM_FIELDS.FULLNAME]: string;
  [HELP_FORM_FIELDS.EMAIL]: string;
  [HELP_FORM_FIELDS.MOBILE]: string;
  [HELP_FORM_FIELDS.IMAGE]: File | null;
  [HELP_FORM_FIELDS.MESSAGE]: string;
  [HELP_FORM_FIELDS.STATUS]: EnquiryStatus;
}

export const HelpFormLabels: Record<string, string> = {
  [HELP_FORM_FIELDS.FULLNAME]: 'Name',
  [HELP_FORM_FIELDS.EMAIL]: 'Email',
  [HELP_FORM_FIELDS.MOBILE]: 'Phone Number',
  [HELP_FORM_FIELDS.IMAGE]: 'Image',
  [HELP_FORM_FIELDS.MESSAGE]: 'Description',
  [HELP_FORM_FIELDS.STATUS]: 'Status'
}

export const defaultHelpFormValues: HelpForm = {
  [HELP_FORM_FIELDS.FULLNAME]: '',
  [HELP_FORM_FIELDS.EMAIL]: '',
  [HELP_FORM_FIELDS.MOBILE]: '',
  [HELP_FORM_FIELDS.IMAGE]: null,
  [HELP_FORM_FIELDS.MESSAGE]: '',
  [HELP_FORM_FIELDS.STATUS]: EnquiryStatus.PENDING
}

export const helpFormValidationSchema = Yup.object({
  [HELP_FORM_FIELDS.FULLNAME]: Yup.string()
    .required('Name is required')
    .min(3, 'Name must be at least 3 characters long')
    .max(50, 'Name must be at most 50 characters long'),

  [HELP_FORM_FIELDS.EMAIL]: Yup.string()
    .email('Invalid email format')
    .required('Email is required'),
  [HELP_FORM_FIELDS.MOBILE]: Yup.string()
    .matches(/^\+?[1-9]\d{7,14}$/, 'Invalid phone number')
    .required('Phone number is required'),
  [HELP_FORM_FIELDS.MESSAGE]: Yup.string()
    .required('Message is required')
    .min(10, 'Description must be at least 10 characters long')
    .max(500, 'Description must be at most 500 characters long')
})

export const getInitialHelpFormValuesResponse = (
  response: Partial<HelpForm>
): HelpForm => {
  return cloneDeep({
    [HELP_FORM_FIELDS.FULLNAME]: response.fullName || '',
    [HELP_FORM_FIELDS.EMAIL]: response.email || '',
    [HELP_FORM_FIELDS.MOBILE]: response.mobile || '',
    [HELP_FORM_FIELDS.IMAGE]: response.image || null,
    [HELP_FORM_FIELDS.MESSAGE]: response.message || '',
    [HELP_FORM_FIELDS.STATUS]: response.status || EnquiryStatus.PENDING
  })
}
